// extracted by mini-css-extract-plugin
export var divider = "_r9-0";
export var systemMessage = "_r9-1";